import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentUser = this.authService.getUser();
    const userToken = this.authService.getToken();
    const isSignedIn = currentUser && userToken;
    if (isSignedIn) {
      request = request.clone({
        setHeaders: {
          Authorization: userToken
        }
      });
    }
    return next.handle(request);
  }
}
